import React from 'react';

const STEPS = [
  ['Send us your menu', 'Photos of the printed menu work best. Include your prices, hours and the dishes you’d love to sell more of.'],
  ['We build your assistant', 'Menu, sizes, spice levels, upsell pairings, greeting, voice and languages, all tuned to your restaurant.'],
  ['Test it on real calls', 'Call it yourself and try to trip it up. We adjust until it sounds like your best host.'],
  ['Go live', 'Forward your existing number or get a new one. Orders start printing in your kitchen.'],
];

export default function HowItWorks() {
  return (
    <section className="section light" id="how-it-works">
      <div className="wrap">
        <div className="section__head section__head--center" data-reveal>
          <p className="eyebrow">Getting started</p>
          <h2 className="h2">
            We set it up for you. <em>No setup work for you.</em>
          </h2>
        </div>
        <ol className="steps">
          {STEPS.map(([title, body], i) => (
            <li key={title} className="step" data-reveal>
              <span className="step__no">{String(i + 1).padStart(2, '0')}</span>
              <h3>{title}</h3>
              <p>{body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
